import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { Text } from 'breadcrumbs-ui/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuPickerTitle = memoWithDisplayName('MenuPickerTitle', ({
  title
}) => {
  return /*#__PURE__*/_jsx(Text, {
    color: "text-primary-disabled",
    typography: "heading-50",
    "data-test-id": "menu-picker-title",
    whiteSpace: "pre-wrap",
    display: "inline-block",
    children: title
  });
});